<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange" :hideBtns="true">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="add" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
    </Table>

    <FormDialog ref="dialog" :title="title" :width="'540px'" :labelWidth="'100px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onChange="onModalChange" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import { mapState, mapMutations } from "vuex";

export default {
  mixins: [tableMixin],
  data() {
    return {
      breadcrumb: [
        { name: "客户管理" },
        { name: "客户列表" },
        { name: "路线管理" },
      ],
      baseUrl: 'custom',
      getListUrl: 'custom_route_rec',
      modalSubmitUrl: 'custom_route_addedu',
      delUrl: 'custom_route_delre',
      formInline: {},
      formCtrl: [],
      cols: [
        { keyName: "route_name", label: "路线名称" },
        { keyName: "coaddress", label: "装货地址" },
        { keyName: "drman", label: "装货联系人" },
        { keyName: "drtel", label: "联系电话" },
        { keyName: "enaddress", label: "卸货地址" },
        { keyName: "enman", label: "卸货联系人" },
        { keyName: "ertel", label: "联系电话" },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({
            id,
            route_name,
            coaddress,
            drman,
            drtel,
            enaddress,
            enman,
            ertel,
          }) => {
            this.title = '修改路线'
            this.viewMode = false
            const { custom_id } = this.$route.query

            this.mform = {
              id,
              custom_id,
              route_name,
              coaddress,
              drman,
              drtel,
              enaddress,
              enman,
              ertel,
            }
            // this.$set(this.mform, 'custom_id', custom_id)
            // console.log({ ...this.mform })
            this.showDialog()
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      title: '添加路线',
      mform: {
        route_name: undefined,
        coaddress: undefined,
        drman: undefined,
        drtel: undefined,
        enaddress: undefined,
        enman: undefined,
        ertel: undefined,
      },
      mrules: {
        route_name: [
          {
            required: true,
            message: '请填写路线名称',
            trigger: 'blur',
          }
        ],
        coaddress: [
          {
            required: true,
            message: '请填写装货地址',
            trigger: 'blur',
          }
        ],
        drman: [
          {
            required: true,
            message: '请填写装货联系人',
            trigger: 'blur',
          }
        ],
        drtel: [
          {
            required: true,
            validator: this.checkPhone,
            trigger: 'blur',
          }
        ],
        enaddress: [
          {
            required: true,
            message: '请填写卸货地址',
            trigger: 'blur',
          }
        ],
        enman: [
          {
            required: true,
            message: '请填写卸货联系人',
            trigger: 'blur',
          }
        ],
        ertel: [
          {
            required: true,
            validator: this.checkPhone,
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "路线名称",
          keyName: "route_name",
          err: "请填写路线名称",
          type: "text",
        },
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
        },
        {
          label: "装货联系人",
          keyName: "drman",
          err: "请填写装货联系人",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "drtel",
          err: "请填写装货联系电话",
          type: "text",
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
        },
        {
          label: "卸货联系人",
          keyName: "enman",
          err: "请填写卸货联系人",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "ertel",
          err: "请填写卸货联系电话",
          type: "text",
        },
      ],
      viewMode: false,
      baseParams: ['custom_id'],
    };
  },
  computed: {
    ...mapState([
      'store'
    ]),
  },
  methods: {
    ...mapMutations([
      'setState'
    ]),
    add() {
      this.title = '添加路线'
      this.viewMode = false
      const { custom_id } = this.$route.query
      this.$set(this.mform, 'custom_id', custom_id)
      // console.log({ ...this.mform })
      this.showDialog()
    },
  },
  created() { },
  mounted() {
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped></style>
